export default __webpack_public_path__ + "static/yelpLogo-1b7316edc5c9a2fcc57875c640e40080.png";